import { useParams, useSearchParams } from 'react-router-dom';

import { AppUpdateAdPage } from '~/components/pages/AppUpdateAdPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateAdRoute: React.FC = () => {
  const { appId, adId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!appId || !adId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateAdPage
        appId={appId}
        adId={adId}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        cancelUrl={searchParams.get('cancelUrl') ?? undefined}
      />
    </DashboardTemplate>
  );
};
